import { type QuestionPropsBase } from "features/Library/Common/QuestionsForm/types";
import { WithFormikPayload } from "features/Library/Common/Fields/WithFormikPayload";
import InputField from "features/Library/Common/Fields/InputField";
import styles from "./SurveyRateQuestion.module.scss";
import { type RatingScale } from "../types";
import { TextQuestion } from "features/Library/Common/QuestionsForm/Questions/QuestionFields/TextQuestion/TextQuestion";
import { MAX_RATE_LABEL_LENGTH } from "features/Library/Common/constants";

export type TextQuestionProps = QuestionPropsBase<RatingScale>;

export const SurveyRateQuestion = (props: TextQuestionProps) => {
  const { question, propertyNamePrefix, onBlur, disabled, validatedFieldProps, index, onChanged } = props;
  const { setFieldValue, setFieldTouched } = validatedFieldProps;

  const getPropertyName = (key: keyof RatingScale) => `${propertyNamePrefix}question.${key}`;

  return (
    <div className={styles.root}>
      <TextQuestion
        question={question.text}
        propertyName={getPropertyName("text")}
        index={index}
        onBlur={onBlur}
        onChanged={onChanged}
        validatedFieldProps={validatedFieldProps}
        disabled={disabled}
      />
      <div className={styles.labels}>
        <WithFormikPayload
          propertyName={getPropertyName("minRateLabel")}
          {...validatedFieldProps}
          selfValidation
          render={(formikProps) => (
            <InputField
              placeholder={"Lowest rank label"}
              value={question.minRateLabel}
              errorPosition={"bottom"}
              onBlur={onBlur}
              disabled={disabled}
              setFieldTouched={setFieldTouched}
              setFieldValue={setFieldValue}
              maxLength={MAX_RATE_LABEL_LENGTH}
              {...formikProps}
            />
          )}
        />
        <WithFormikPayload
          propertyName={getPropertyName("maxRateLabel")}
          {...validatedFieldProps}
          selfValidation
          render={(formikProps) => (
            <InputField
              placeholder={"Highest rank label"}
              value={question.maxRateLabel}
              errorPosition={"bottom"}
              onBlur={onBlur}
              disabled={disabled}
              setFieldTouched={setFieldTouched}
              setFieldValue={setFieldValue}
              maxLength={MAX_RATE_LABEL_LENGTH}
              {...formikProps}
            />
          )}
        />
      </div>
    </div>
  );
};
